import { TApplicationState } from '../../types/redux';
import { getUser } from './getUser';

export const getUserPhone = (state: TApplicationState) => {
  const user = getUser(state);
  const phone = user?.phone;

  return phone || null;
};
